

























import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class AxSwitchButton extends Vue {
  @Prop({ type: String, default: '' })
  label!: string;

  @Prop({ type: Boolean, default: false })
  value!: boolean;

  @Prop({ type: Boolean, default: false })
  lighten!: boolean;

  @Prop({ type: Boolean, default: false })
  disabled!: boolean;
}
